//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CSelect from '../../CSelect'
import CRadioCard from '../../CSelect/CRadioCard'
import BSelectSchoolOtherPage from './BSelectSchoolOtherPage'

export default {
  name: 'BSelectGraduationSchool',

  components: {
    CSelect,
    CRadioCard,
  },

  props: {
    apiMethod: { type: Function },

    saveMethod: { type: Function },

    postMethod: { type: Function },

    value: {
      type: [
        String,
        Number,
      ],
      default: '',
    },

    formComponent: { type: Object },

    addFormRender: {
      type: Array,
      default: () => ([]),
    },

    valueName: {
      type: String,
      default: 'key',
    },

    searchCardFormat: {
      type: [
        Array,
        Function,
      ],
      default: () => {
        return [
          {
            label: '中学名称',
            value: 'name',
          },
          {
            label: '地区',
            value: 'sydqWidDisplayValue',
          },
        ]
      },
    },
  },

  data () {
    return { BSelectSchoolOtherPage }
  },

  computed: {
    innerValue: {
      set (val) {
        this.$emit('input', val)
      },
      get () {
        return this.value
      },
    },
  },

  methods: {
    radioCardClick (item) {
      this.$set(item, 'active', !item.active)
    },
  },
}
